/* AJP – AMP Upsells: Free Gift Market Gate (minimal, extendable)
   Scope NOW: Only handles the cart drawer free-gift block `.amp-cart__free-gifts`.
   Later: We'll extend for upsell journeys in a new section.

   REQUIREMENT: theme.liquid sets window.__MARKET__ (country + market handle).
   Example snippet already added:
     window.__MARKET__ = { country: "GB", market: "gb", currency: "GBP" };
*/

(() => {
  // ===== CONFIG (edit without touching code below) =====
  // Use market handle by default (e.g. "gb", "united-states")
  const CONFIG = {
    // Allow list by MARKET HANDLE (preferred)
    allowMarkets: new Set(['gb']), // ← Only show free gift in these markets
    // Optional: allow list by COUNTRY CODE (fallback/extra guard)
    allowCountries: new Set(['GB']),

    // TEST MODE: while building, don't hide; just add a class & console log.
    // Flip to false for go-live (and see "LIVE HIDE" line below).
    testMode: false, /* Uncomment this in geoff.css when you set this to false: .amp-cart-drawer .amp-cart__free-gifts {display: none !important;} */

    // Turn console breadcrumbs on/off
    debug: true
  };

  // ===== UTIL =====
  const log = (...args) => CONFIG.debug && console.log('[AJP][GiftGate]', ...args);
  const getMarket = () => (window.__MARKET__ && window.__MARKET__.market) || document.documentElement.getAttribute('data-market') || '';
  const getCountry = () => (window.__MARKET__ && window.__MARKET__.country) || document.documentElement.getAttribute('data-country') || '';

  function marketAllowed() {
    const m = (getMarket() || '').toLowerCase();
    const c = (getCountry() || '').toUpperCase();
    const okM = CONFIG.allowMarkets.size ? CONFIG.allowMarkets.has(m) : true;
    const okC = CONFIG.allowCountries.size ? CONFIG.allowCountries.has(c) : true;
    // If both allow lists are provided, require BOTH to be true (tight gate).
    // If you prefer "either/or", change to: return okM || okC;
    return okM && okC;
  }

  // ===== CORE: handle the free gift block =====
  function markBlocked(el, reason) {
    el.classList.add('ajp-freegift--blocked');   // TEST-MODE marker (remove for live if you want)
    el.setAttribute('aria-hidden', 'true');
    log('blocked free gift:', reason, { country: getCountry(), market: getMarket() });

    if (!CONFIG.testMode) {
      // LIVE HIDE: uncomment if you want to actually remove from layout now
      // el.style.setProperty('display', 'none', 'important');
    } else {
      // Optional visual cue for testing; remove if not wanted
      el.classList.add('ajp-freegift--debug-outline');
    }
  }

  function markAllowed(el) {
    el.classList.remove('ajp-freegift--blocked', 'ajp-freegift--debug-outline');
    el.removeAttribute('aria-hidden');
    if (!CONFIG.testMode) el.style.removeProperty('display');
    log('allowed free gift', { country: getCountry(), market: getMarket() });
  }

  function evaluateBlock(root = document) {
    const blocks = root.querySelectorAll('.amp-cart__free-gifts');
    if (!blocks.length) return;

    const allow = marketAllowed();
    blocks.forEach(el => (allow ? markAllowed(el) : markBlocked(el, 'market not allowed')));
  }

  // Intercept “Claim” if blocked (defensive; harmless in test mode)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('.amp-cart__free-gifts .amp-cart__free-gifts-item-button');
    if (!btn) return;
    const container = btn.closest('.amp-cart__free-gifts');
    if (!container) return;

    const blocked = container.classList.contains('ajp-freegift--blocked');
    if (blocked) {
      e.preventDefault();
      e.stopPropagation();
      log('prevented Claim click (blocked)');
    }
  }, true);

  // Observe dynamic injection (cart drawer opens, gifts render, etc.)
  const mo = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (!(n instanceof Element)) continue;
        if (n.matches?.('.amp-cart__free-gifts') || n.querySelector?.('.amp-cart__free-gifts')) {
          evaluateBlock(n);
        }
        // Also run when the drawer itself appears
        if (n.matches?.('.amp-cart__drawer') || n.querySelector?.('.amp-cart__drawer')) {
          evaluateBlock(n);
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Initial pass (in case it already exists)
  evaluateBlock();

  // ===== Tiny public API (for toggling without editing the file) =====
  window.AJP_FreeGift = {
    // Show which market/country the gate is using
    info() { return { country: getCountry(), market: getMarket(), allowMarkets: [...CONFIG.allowMarkets], allowCountries: [...CONFIG.allowCountries], testMode: CONFIG.testMode }; },

    // Allow in the given market handles (replaces the set)
    allowInMarkets(list) { CONFIG.allowMarkets = new Set((list || []).map(s => String(s).toLowerCase())); evaluateBlock(); },
    // Allow in the given country codes (replaces the set)
    allowInCountries(list) { CONFIG.allowCountries = new Set((list || []).map(s => String(s).toUpperCase())); evaluateBlock(); },

    // Toggle test mode on the fly
    setTestMode(on) { CONFIG.testMode = !!on; evaluateBlock(); },

    // Force re-check (e.g., after you change overrides)
    refresh() { evaluateBlock(); }
  };

  log('ready', window.AJP_FreeGift.info());
})();
